/* Triply Collection landing page — runtime
   - Sticky catnav offset matches site header height
   - IntersectionObserver scroll-spy highlights active catnav link
   - FAQ accordion (uses <details>, only one open at a time)
*/
(function () {
  'use strict';

  var root = document.querySelector('.triply-lp');
  if (!root) return;

  // ---------- Sticky catnav: align under the global header ----------
  var catnav = root.querySelector('.tpl-catnav');
  function updateHeaderOffset() {
    if (!catnav) return;
    var header =
      document.querySelector('.site-header') ||
      document.querySelector('header.shopify-section-header') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header[role="banner"]') ||
      document.querySelector('header');
    var h = header ? header.getBoundingClientRect().height : 0;
    catnav.style.top = h + 'px';
    root.style.setProperty('--tpl-header-h', h + 'px');
  }
  updateHeaderOffset();
  window.addEventListener('resize', updateHeaderOffset, { passive: true });
  // Re-check after fonts load (header height can shift)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderOffset);
  }

  // ---------- Scroll-spy ----------
  var links = root.querySelectorAll('.tpl-catnav-link');
  var sections = [];
  links.forEach(function (a) {
    var id = a.getAttribute('data-target');
    if (!id) return;
    var el = document.getElementById(id);
    if (el) sections.push({ id: id, el: el, link: a });
  });

  function setActive(id) {
    links.forEach(function (a) {
      if (a.getAttribute('data-target') === id) {
        a.classList.add('is-active');
        // Keep the active link scrolled into view inside the horizontal nav
        var nav = root.querySelector('.tpl-catnav-inner');
        if (nav && a.offsetLeft < nav.scrollLeft) {
          nav.scrollTo({ left: Math.max(0, a.offsetLeft - 40), behavior: 'smooth' });
        } else if (nav && a.offsetLeft + a.offsetWidth > nav.scrollLeft + nav.clientWidth) {
          nav.scrollTo({
            left: a.offsetLeft - nav.clientWidth + a.offsetWidth + 40,
            behavior: 'smooth'
          });
        }
      } else {
        a.classList.remove('is-active');
      }
    });
  }

  if ('IntersectionObserver' in window && sections.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        // pick the most visible
        var best = null;
        entries.forEach(function (e) {
          if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) {
            best = e;
          }
        });
        if (best) setActive(best.target.id);
      },
      { rootMargin: '-30% 0px -55% 0px', threshold: [0, 0.15, 0.3] }
    );
    sections.forEach(function (s) { observer.observe(s.el); });
  }

  // ---------- Anchor click → smooth scroll with sticky offset ----------
  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('data-target');
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var headerH = catnav ? catnav.getBoundingClientRect().bottom : 0;
      var y = el.getBoundingClientRect().top + window.pageYOffset - headerH - 8;
      window.scrollTo({ top: y, behavior: 'smooth' });
      setActive(id);
    });
  });

  // Hero CTA buttons that point at section ids
  root.querySelectorAll('a.tpl-btn[data-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var id = btn.getAttribute('data-scroll-to');
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var headerH = catnav ? catnav.getBoundingClientRect().bottom : 0;
      var y = el.getBoundingClientRect().top + window.pageYOffset - headerH - 8;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  // ---------- Product card variant dropdown ----------
  function closeAllVariantDropdowns(except) {
    root.querySelectorAll('.tpl-card-variant-select.is-open').forEach(function (s) {
      if (s === except) return;
      s.classList.remove('is-open');
      var dd = s.querySelector('.tpl-card-variant-dropdown');
      if (dd) dd.setAttribute('hidden', '');
      var t = s.querySelector('.tpl-card-variant-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  root.querySelectorAll('.tpl-card-variant-select').forEach(function (selectEl) {
    var trigger = selectEl.querySelector('.tpl-card-variant-trigger');
    var dropdown = selectEl.querySelector('.tpl-card-variant-dropdown');
    var valueEl = selectEl.querySelector('.tpl-card-variant-trigger-value');
    var options = selectEl.querySelectorAll('.tpl-card-variant-option');
    if (!trigger || !dropdown) return;

    function open() {
      closeAllVariantDropdowns(selectEl);
      selectEl.classList.add('is-open');
      dropdown.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      selectEl.classList.remove('is-open');
      dropdown.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function toggle(e) {
      e.preventDefault();
      e.stopPropagation();
      if (selectEl.classList.contains('is-open')) close();
      else open();
    }

    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') toggle(e);
    });

    options.forEach(function (opt) {
      function selectOpt(e) {
        e.preventDefault();
        e.stopPropagation();
        options.forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-selected', 'false');
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-selected', 'true');
        if (valueEl) valueEl.textContent = opt.getAttribute('data-variant-title');
        var card = selectEl.closest('.tpl-card');
        var url = opt.getAttribute('data-variant-url');
        if (card && url) card.setAttribute('href', url);

        // Update CTA based on availability
        if (card) {
          var cta = card.querySelector('.tpl-card-cta');
          var ctaText = card.querySelector('.tpl-card-cta-text');
          var isAvail = opt.getAttribute('data-variant-available') === 'true';
          if (cta) cta.classList.toggle('is-oos', !isAvail);
          if (ctaText) ctaText.textContent = isAvail ? 'Order Now' : 'Out of Stock';
        }
        close();
      }
      opt.addEventListener('click', selectOpt);
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') selectOpt(e);
      });
    });

    dropdown.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  // Close dropdowns on outside click or Escape
  document.addEventListener('click', function () { closeAllVariantDropdowns(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllVariantDropdowns();
  });

  // ---------- Marquee: pause when off-screen or tab hidden (saves CPU) ----------
  var marqueeTrack = root.querySelector('.tpl-marquee-track');
  if (marqueeTrack) {
    function setMarqueeState(running) {
      marqueeTrack.style.animationPlayState = running ? 'running' : 'paused';
    }
    if ('IntersectionObserver' in window) {
      var marqueeObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { setMarqueeState(e.isIntersecting); });
      }, { threshold: 0 });
      marqueeObs.observe(marqueeTrack);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) setMarqueeState(false);
      else setMarqueeState(true);
    });
  }

  // ---------- FAQ: one open at a time ----------
  var faqItems = root.querySelectorAll('.tpl-faq-item');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        faqItems.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }
    });
  });
})();
